export default "__VITE_ASSET__8922833c__"